import ContactForm from "../ContactForm";

export default function ContactFormSec() {
    return (
        <>
            <section id="contact-section" className="contact-page-contact-section">
                <div className="contact-container">
                    <div className="contact-header">
                        <h2 className="section-title">SEND US MESSAGE</h2>
                    </div>
                    <div className="contact-content">
                        <ContactForm />
                    </div>
                </div>
            </section>
        </>
    );
}